import { useTranslation } from 'react-i18next';
import { CardBox } from '~/components/ui/Card';
import NameSection from './NameSection';

export default function ProfileInformation() {
  const { t } = useTranslation();

  return (
    <section>
      <h2 className="mb-3 text-sm font-semibold text-section-title">{t('profile.title')}</h2>
      <CardBox className="p-0">
        <NameSection isLast />
      </CardBox>
    </section>
  );
}
